import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_theme_selector = _resolveComponent("theme-selector")!

  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default"),
    ($setup.showThemeSelector)
      ? (_openBlock(), _createBlock(_component_theme_selector, {
          key: 0,
          "current-theme": $setup.currentThemeName,
          onChangeTheme: $setup.selectPortalTheme
        }, null, 8, ["current-theme", "onChangeTheme"]))
      : _createCommentVNode("", true)
  ]))
}